import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout';
import Artwork from '../../components/artwork';
import SafetyNetOverview from '../../components/SafetyNetOverview';
import { getArtworkCnt, getArtworks, selectArtworkCnt, selectArtworks, selectCurrentPage, setCurrentPage } from '../../redux/artworkReducer';
import { fetchDashboardStats } from '../../redux/aiReducer';
import { useDispatch, useSelector } from 'react-redux';
import Paginate from 'react-paginate';

const Dashboard = () => {
    const dispatch = useDispatch();
    const artworkList = useSelector(selectArtworks);
    const artworkCnt = useSelector(selectArtworkCnt);
    const currentPage = useSelector(selectCurrentPage);

    const [offset, setOffset] = useState(1);
    const [dashboardStats, setDashboardStats] = useState(null);
    const [statsLoading, setStatsLoading] = useState(true);
    const [statsError, setStatsError] = useState(null);

    const getData = async (pageOffset) => {
        dispatch(getArtworks('', '', false, 10, pageOffset));
    };

    const handlePageClick = (e) => {
        const selectedPage = e.selected;
        setOffset(selectedPage + 1);
        dispatch(setCurrentPage(selectedPage + 1));
    };

    useEffect(() => {
        getData(offset - 1);
    }, [offset]);

    const init = async () => {
        setStatsLoading(true);
        setStatsError(null);
        const stats = await dispatch(fetchDashboardStats());
        if (stats) {
            setDashboardStats(stats);
        } else {
            setStatsError('Overview stats are unavailable. Check that the API is running on port 4000.');
        }
        setStatsLoading(false);
        await dispatch(getArtworkCnt());
    };

    useEffect(() => {
        init();
    }, []);

    return (
        <Layout>
            <SafetyNetOverview stats={dashboardStats} loading={statsLoading} error={statsError} />

            {artworkCnt === 0 && (
                <div className="text-center py-16 px-4 text-gray-600">
                    <p className="text-lg font-semibold text-gray-800 mb-2">No registered artworks yet</p>
                    <p className="max-w-md mx-auto">
                        SafetyNet scans artworks registered on the main ATO platform.
                        Add artwork at{' '}
                        <a href="http://localhost:3000" className="text-ato-red underline">
                            localhost:3000
                        </a>{' '}
                        (artist account), then refresh this page.
                    </p>
                </div>
            )}

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 max-w-7xl mx-auto">
                {artworkList.map(((artwork, key) => <Artwork key={key} info={artwork} />))}
            </div>

            {artworkCnt > 0 && (
            <nav className="flex justify-center mt-10 mb-6" aria-label="Artwork pages">
                <Paginate
                    previousLabel="Previous"
                    nextLabel="Next"
                    breakLabel="…"
                    breakClassName="break-me"
                    pageCount={Math.ceil(artworkCnt / 10) || 1}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName="pagination"
                    subContainerClassName="pages pagination"
                    activeClassName="active"
                    disabledClassName="disabled"
                    initialPage={currentPage - 1}
                />
            </nav>
            )}
        </Layout>
    );
};

export default Dashboard;
